"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callAccessTokenApi = callAccessTokenApi;
exports.callCheckEmailExistApi = callCheckEmailExistApi;
exports.callCheckUserExistApi = callCheckUserExistApi;
exports.deleteAccount = deleteAccount;
exports.getCountryFlagsData = getCountryFlagsData;
exports.getEmailDataApi = getEmailDataApi;
exports.requestDeleteAccount = requestDeleteAccount;
var _ApiConst = require("../../../../common/utils/ApiConst");
var _genericFetch = _interopRequireWildcard(require("../../../../common/api/genericFetch"));
var _utils = require("../../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-undef */
/* eslint-disable no-useless-catch */

function callCheckUserExistApi(requestParams, tokenData) {
  const {
    mobile,
    id
  } = requestParams;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  let queryParam = `mobile=${mobile}&id=${id}`;
  if (requestParams !== null && requestParams !== void 0 && requestParams.isCheckoutCall) {
    queryParam += `&epharmacyCheckoutCall=${requestParams.isCheckoutCall}`;
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}patient-service/Patient?${queryParam}`;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getEmailDataApi(requestParams, tokenData) {
  const {
    patientId
  } = requestParams;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.GET_EMAIL_DATA}?userId=${patientId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function callCheckEmailExistApi(requestParams, tokenData) {
  const {
    email
  } = requestParams;
  const apiEndPoint = `${_ApiConst.BASE_URL}user-common-service/User/checkEmail?email=${email}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function requestDeleteAccount(requestParams, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.DELETE_ACCOUNT_SUPPORT_TICKET_API}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = requestParams;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: requestParams, requestType: API_PARAMS.POST });
}
function deleteAccount(requestParams, tokenData) {
  const {
    id
  } = requestParams;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.COMPLETE_PATIENT_PROIFLE_INFO}${id}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.DELETE;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.DELETE });
}
async function callAccessTokenApi(requestParams) {
  if (requestParams !== null && requestParams !== void 0 && requestParams.isRefreshTokenGrant) {
    try {
      const token = (0, _utils.isMobile)() ? requestParams === null || requestParams === void 0 ? void 0 : requestParams.expiredAccessToken : (0, _ApiConst.getDataFromCookieAToB)('kcToken');
      const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.AUTH_REFRESH_TOKEN}`;
      const options = {
        headers: {
          Authorization: token ? `Bearer ${token}` : null
        }
      };
      options.method = _ApiConst.API_PARAMS.POST;
      options.body = {
        refreshToken: requestParams === null || requestParams === void 0 ? void 0 : requestParams.refreshToken
      };
      return (0, _genericFetch.default)({
        apiEndPoint,
        options
      });
    } catch (e) {
      throw e;
    }
  }
}
function getCountryFlagsData() {
  const options = {};
  options.method = _ApiConst.API_PARAMS.GET;
  const apiEndPoint = `${_ApiConst.BLOB_DATA_BASE_URL}${_ApiConst.COUNTRY_PICKER_MENU_DATA}`;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}